/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseDto } from './CaseDto';
import {
    CaseDtoFromJSON,
    CaseDtoFromJSONTyped,
    CaseDtoToJSON,
    CaseDtoToJSONTyped,
} from './CaseDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CaseListResponse
 */
export interface CaseListResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof CaseListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CaseListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CaseListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<CaseDto>}
     * @memberof CaseListResponse
     */
    data?: Array<CaseDto>;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the CaseListResponse interface.
 */
export function instanceOfCaseListResponse(value: object): value is CaseListResponse {
    return true;
}

export function CaseListResponseFromJSON(json: any): CaseListResponse {
    return CaseListResponseFromJSONTyped(json, false);
}

export function CaseListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CaseDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function CaseListResponseToJSON(json: any): CaseListResponse {
    return CaseListResponseToJSONTyped(json, false);
}

export function CaseListResponseToJSONTyped(value?: CaseListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CaseDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

